module.exports = __webpack_public_path__ + "static/media/youtube.bb3ac6d7.svg";